import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
  type PaginatedProductCategoryList,
  StatusCode,
} from '@hungryroot/rest';
import { getApiV2ProductCategories } from '@hungryroot/rest/api/v2/product_categories/get';

type QueryParams = Parameters<typeof getApiV2ProductCategories>[0];

export function getQueryKey(queryParams: QueryParams = {}) {
  return ['Product Categories', queryParams];
}

type UseProductCategoriesProps = {
  queryParams?: QueryParams;
  options?: Omit<
    UseQueryOptions<PaginatedProductCategoryList>,
    'queryFn' | 'queryKey'
  >;
};

export function useProductCategories(props: UseProductCategoriesProps = {}) {
  const { queryParams = {}, options } = props;

  return useQuery({
    queryKey: getQueryKey(queryParams),
    queryFn: async () => {
      const resp = await getApiV2ProductCategories(queryParams);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
  });
}
